module.exports = __webpack_public_path__ + "img/client06.55c28060.jpg";